document.addEventListener('DOMContentLoaded',function(){

  function isPartiallyInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top < window.innerHeight &&
      rect.bottom > 0 &&              
      rect.left < window.innerWidth &&
      rect.right > 0                  
    );
  }

  window.addEventListener('scroll',function(){
    if(document.querySelectorAll('.AS__IngredientList').length > 0){
      if(isPartiallyInViewport(document.querySelector('.AS__IngredientsWrapr'))){
        setInterval(function(){
          document.querySelectorAll('.AS__IngredientList')[0].classList.add('active');
        }, 500);
        setInterval(function(){
          document.querySelectorAll('.AS__IngredientList')[1].classList.add('active');
        }, 1000);
        setInterval(function(){
          document.querySelectorAll('.AS__IngredientList')[2].classList.add('active');
        }, 1500);
        setInterval(function(){
          document.querySelectorAll('.AS__IngredientList')[3].classList.add('active');
        }, 2000);
        setInterval(function(){
          document.querySelectorAll('.AS__IngredientList')[4].classList.add('active');
        }, 2500);
        setInterval(function(){
          document.querySelectorAll('.AS__IngredientList')[5].classList.add('active');
        }, 3000);
        setInterval(function(){
          document.querySelectorAll('.AS__IngredientList')[6].classList.add('active');
        }, 3500);
        setInterval(function(){
          document.querySelectorAll('.AS__IngredientList')[7].classList.add('active');
        }, 4000);
        setInterval(function(){
          document.querySelectorAll('.AS__IngredientList')[8].classList.add('active');
        }, 4500);
      }
    }

    if(document.querySelectorAll('.AS__stepMN').length > 0){
      if(isPartiallyInViewport(document.querySelector('.AS__WhatExpectMain'))){
        setInterval(function(){
          document.querySelectorAll('.AS__stepMN')[0].classList.add('active');
        }, 500);
        setInterval(function(){
          document.querySelectorAll('.AS__stepMN')[1].classList.add('active');
        }, 1000);
        setInterval(function(){
          document.querySelectorAll('.AS__stepMN')[2].classList.add('active');
        }, 1500);
        setInterval(function(){
          document.querySelectorAll('.AS__stepMN')[3].classList.add('active');
        }, 2000);
      }
    }

    if(isPartiallyInViewport(document.querySelectorAll('.AS__stepMN')[3].querySelector('.AS__desc')) || isPartiallyInViewport(document.querySelector('.ing_newMN')) || isPartiallyInViewport(document.querySelector('.AS_OurJrneyMn')) || isPartiallyInViewport(document.querySelector('.comparison-table-section')) || isPartiallyInViewport(document.querySelector('.section-img-text')) || isPartiallyInViewport(document.querySelector('.AS__DirectionUseMain')) || isPartiallyInViewport(document.querySelector('.BeforAfterSectionMAain')) || isPartiallyInViewport(document.querySelector('.MetaFAQSectionMN')) || isPartiallyInViewport(document.querySelector('footer')) || isPartiallyInViewport(document.querySelector('.AS__sidebarItem'))){
      document.querySelector('.sticky_mob_view').classList.add('active');
      document.querySelector('.sticky_outer_most').classList.add('active');
      document.querySelector('.sticky_atcMN').classList.add('active');
    }else{
      document.querySelector('.sticky_mob_view').classList.remove('active');
      document.querySelector('.sticky_outer_most').classList.remove('active');
      document.querySelector('.sticky_atcMN').classList.remove('active');
    }
    if(isPartiallyInViewport(document.querySelector('.ing_newMN')) || isPartiallyInViewport(document.querySelector('.AS_OurJrneyMn')) || isPartiallyInViewport(document.querySelector('.comparison-table-section')) || isPartiallyInViewport(document.querySelector('.section-img-text')) || isPartiallyInViewport(document.querySelector('.AS__DirectionUseMain')) || isPartiallyInViewport(document.querySelector('.BeforAfterSectionMAain')) || isPartiallyInViewport(document.querySelector('.MetaFAQSectionMN'))){
      document.querySelector('.AS__sidebarItem').classList.add('active');
    }else{
      document.querySelector('.AS__sidebarItem').classList.remove('active');
    }
  });

  if(document.querySelector('.sticky_outer_most')){
    var sticky_outer_most_height = document.querySelector('.sticky_outer_most').offsetHeight
    document.querySelector('.sticky_outer_most').style.setProperty('--height', sticky_outer_most_height+'px');
  }

  var popup_target = document.querySelectorAll('.popup_target');
  if(popup_target.length > 0){
    popup_target.forEach(function(pop){
      pop.addEventListener('click',function(e){
        e.preventDefault();
        document.body.classList.add('pop_active');
        this.closest('.block_media').querySelector('.popup_detailsMN').classList.add('active');
      })
    })
  }
  var popup_close = document.querySelectorAll('.close_pop');
  if(popup_close.length > 0){
    popup_close.forEach(function(close){
      close.addEventListener('click',function(e){
        e.preventDefault();
        document.body.classList.remove('pop_active');
        this.closest('.block_media').querySelector('.popup_detailsMN').classList.remove('active');
      })
    })
  }

  var header_menu = document.querySelectorAll('.site-nav li'), mobile_menu = document.querySelectorAll('#mobile_menu li');
  if(header_menu.length > 0){
    header_menu.forEach(function(link, index){
      link.addEventListener('click',function(e){
        e.preventDefault();
        var headerOffset = 86;
        if(index == 0){
          var target = document.querySelector('#MainpdpProduct--Box2')
          if (target) {
            var targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
            var offsetPosition = targetPosition - headerOffset;
    
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        }else if(index == 1){
          var target = document.querySelector('.AS_OurJrneyMn')
          if (target) {
            var targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
            var offsetPosition = targetPosition - headerOffset;
    
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        }else if(index == 2){
          var target = document.querySelector('footer')
          if (target) {
            var targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
            var offsetPosition = targetPosition - headerOffset;
    
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        }
      })
    })
  }
  if(mobile_menu.length > 0){
    mobile_menu.forEach(function(link, index){
      link.addEventListener('click',function(e){
        e.preventDefault();
        var headerOffset = 86;
        if(index == 0){
          var target = document.querySelector('#MainpdpProduct--Box2')
          if (target) {
            var targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
            var offsetPosition = targetPosition - headerOffset;
    
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        }else if(index == 1){
          var target = document.querySelector('.AS_OurJrneyMn')
          if (target) {
            var targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
            var offsetPosition = targetPosition - headerOffset;
    
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        }else if(index == 2){
          var target = document.querySelector('footer')
          if (target) {
            var targetPosition = target.getBoundingClientRect().top + window.pageYOffset;
            var offsetPosition = targetPosition - headerOffset;
    
            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        }
      })
    })
  }
  
})